import styled from 'styled-components';

const CreditsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  font-family: Helvetica, Arial, sans-serif;
  // @media (min-width: 1024px) {
  //   height: 150px;
  // }
`;
const CreditsFlex = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 30px;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
const Text = styled.div`
  font-weight: bold;
  font-size: 15px !important;
  color: #4a4a4a;
  line-height: 1.5;
`;
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0;

  span {
    width: 100%;
    color: #4a4a4a;
    font-weight: bold;
    font-size: 14px;
  }

  .actual {
    font-size: 10px !important;
    span {
      width: 15%;
      color: #ff0c0c;
      font-weight: normal;
      font-size: 10px;
      margin: 10px 0;
    }

    &:after {
      position: absolute;
      top: 35px;
      line-height: 20px;
      font-size: 14px;
      text-transform: none;
      text-align: left !important;
      right: 22px;
      @media (max-width: 1024px) {
        right: 26px;
      }
    }
  }
  .previous {
    font-size: 10px !important;
    span {
      width: 15%;
      color: #ff0c0c;
      font-weight: normal;
      font-size: 10px;
      margin: 10px 0;
    }

    &:after {
      position: absolute;
      top: 35px;
      line-height: 20px;
      font-size: 14px;
      text-transform: none;
      text-align: left !important;
      right: 20px;
      @media (max-width: 1024px) {
        right: 20px;
      }
    }
  }
  div {
    width: 48%;
    position: relative;
    // overflow: hidden;
    label {
      color: #4a4a4a;
      font-size: 12px;
    }
    input {
      padding: 8px;
      margin-top: 8px;
      width: 89%;
      // width: 100%;
      border: 1px solid #b2b2b2;
      border-radius: 4px !important;
      transition: 0.3s;
      &:focus {
        outline: none;
        border: 1px solid blue;
      }

      @media (max-width: 1024px) {
        width: 94%;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    span {
      width: 100%;
    }
    div {
      width: 100%;
    }
  }
`;
const Subtitle = styled.div`
  font-size: var(--typo-title2-font-size);
  line-height: var(--typo-title2-line-height);
  color: var(--colors-on-background);
  font-family: var(--typo-title1-font-family);
  letter-spacing: var(--typo-title1-letter-spacing);
  font-weight: var(--typo-title1-font-weight);
  @media (min-width: 1024px) {
    font-size: var(--typo-title1-font-size);
    line-height: var(--typo-title1-line-height);
  }
`;
const ProjectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  selected-button {
    max-width: 40px;
    position: relative;
    padding: 0;
    background: #3a913f;
    color: white;
    float: right !important;
  }
  .to-validate {
    div {
      margin-right: 0;
      margin-left: auto;
    }
  }
`;
const ButtonFlex = styled.div`
  display: flex;
  @media (max-width: 1024px) {
    justify-content: center;
  }
  button {
    border: 0.5px solid black;
    border-radius: 3px;
    font-size: 26px;
    height: 32px;
    width: 32px;
    display: inline-block !important;
    // margin-top: 16px;
    cursor: pointer;
    color: #3a913f;
    background: white;
    &:hover {
      border-color: #268038;
      background: #eff8f0;
    }
  }
  button:disabled,
  button[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    border-color: #b1b5b9;
    color: #b1b5b9;
  }
  .plus {
    margin-left: 12px;
  }
  .minus {
    margin-left: 5px;
    // margin-top: 16px;
    margin-right: 12px;
  }
  .value {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    width: 32px;
    margin: 0px 15px;
    height: 34px;
    color: #4b4f54;
    border-bottom: solid 1px #c9e7ca;
  }
`;
const SumFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;

  @media (max-width: 1024px) {
    flex-direction: row;
    width: 100%;
    margin-left: 0;
  }
`;
const SumFlexBlock = styled.div`
  width: 48%;
  // background-color: rgb(229, 245, 253);
  background-color: #e8f5e9;
  align-items: center;
  border-radius: 5px;
  font-weight: bold;
  color: #4a4a4a;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 14px;
  padding-bottom: 14px;
  .value {
    font-size: 16px;
    vertical-align: middle;
    padding-right: 8px;
    text-align: right;
  }
  .text {
    font-size: 10px;
    font-weight: bold;
    color: #4a4a4a;
    padding-left: 8px;
    line-height: 1.5;
    width: 45%;
  }
  @media (max-width: 1024px) {
    .text {
      font-size: 12px;
      width: 90%;
    }
    .value {
      float: left !important;
      padding-right: auto;
      padding: 8px;
      width: 100%;
    }
`;
interface Props {
  display: boolean;
}

const test = styled.div<Props>`
  display: ${(props) => (props.display ? 'block' : 'none')};
  // display: none;
`;

const Info = styled.div`
  background-color: rgb(229, 245, 253);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 30px !important;
  // min-width: 95%;
  font-family: 'Open Sans' !important;
`;
const TextDiv = styled.div`
  font-size: 12px;
  color: #4a4a4a;
  font-family: Helvetica, Arial, sans-serif;
`;
export default {
  CreditsContainer,
  CreditsFlex,
  Text,
  Container,
  Subtitle,
  ProjectContainer,
  ButtonFlex,
  SumFlex,
  SumFlexBlock,
  test,
  Info,
  TextDiv,
};
